module.exports = __webpack_public_path__ + "img/uart4.612bce01.png";